<template>
    <div class="layout">
        <PcHeader v-if="!isH5" />
        <template  v-if="isH5" >
            <SearchGame/>
            <DownBack/>
        </template>
        <div class="error-wrapp">
            <div class="error_top">
                <img src="https://cdn.ourplay.net/gamestoday/public/gamestoday_404.png" />
                <p>Page Not Found</p>
                <p class="error_goHome">
                    Go back home&nbsp;&nbsp;(&nbsp;<span id="countDown">{{ seconds }}</span
                    >s<span class="dot">...</span>&nbsp;)
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import DownBack from '@/components/downBack.vue'
import SearchGame from '@/components/searchGame.vue'
import PcHeader from '@/components/PcHeader.vue'
import resizeMixin from '@/mixins/resizeMixin'
export default {
  components: {
    DownBack,
    SearchGame,
    PcHeader
  },
    data() {
        return {
            seconds: 5,
        }
    },
    mixins: [resizeMixin],
    mounted() {
        this.timer = setInterval( () => {
            if (this.seconds > 0) {this.seconds --}
            if (this.seconds === 0) {
                location.href = "/"
                clearInterval(this.timer)
            }
        },1000)  
    }
}
</script>

<style lang='scss' scoped>
.layout{
    font-size: 16px;
    overflow: hidden;
    .error_top {
        margin: 0 auto;
        text-align: center;
        img {
            width: 280px;
        }
        p {
            line-height: 30px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/errorPage.vue